import { useEffect, useState } from 'react';
import User from 'benchmarking-domain/user';

import useApi from './use-api';
import { useOrganisation } from './use-organisation';

export function useUsersEmailToNameMap() {
  const { organisationId } = useOrganisation();

  const [usersEmailToNameMap, setUsersEmailToNameMap] = useState<Map<string, string | undefined>>(new Map());
  const { subscribeUsers } = useApi();

  useEffect(() => {
    if (!organisationId) {
      return;
    }

    const unsubscribeUsers = subscribeUsers(organisationId, (results: User[]) => {
      const mappedUsers = new Map(results.map((u) => [u.email, u.name]));
      setUsersEmailToNameMap(mappedUsers);
    });

    return () => {
      unsubscribeUsers();
    };
  }, [organisationId, setUsersEmailToNameMap, subscribeUsers]);

  return { usersEmailToNameMap };
}
